export default __webpack_public_path__ + "static/media/m-fsk-20.30dda91d.jpg";